var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"work-sta-total"},[_c('part-title',{attrs:{"title":"总体对比"}}),_c('div',{ref:"total-chart",staticClass:"work-sta-total__chart-spot"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }